// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** North Korea */
const KP = /^(?:19[1-3]\d{7})$/;

export default KP;
